import { useContext } from 'react';

import { UserDataContext } from '../contexts';

export default function useUserDataContext() {
  return useContext(UserDataContext);
}
